const simulatorConstants = {
    RANGE_TIME_DAP: 900,
    HOLIDAYS: 'I',
}

export default simulatorConstants;